import {Button, Form, Input, InputNumber, message, notification, Popover, Select, TableColumnType} from "antd"
import moment from "moment"
import React, { ReactElement, useState } from "react"
import { DateTimeFormat, DateTimeFormatSimplePrintCharge } from "../../../models/datetime"
import { Dimen } from "../../../models/dimen"
import { getTreatmentPartsName, TreatmentPartsCategoris } from "../../../models/setmeal"
import { MinusOutlined, PlusOutlined } from "@ant-design/icons"
import styles from './peddingMedicalTreatment.module.css'
import {RecipeCategory} from "../../../models/recipe";
import bwwxwImg from "../../treatment/images/bwxwImg.png";

export const Columns = (
  onClick: (text: string, t: any) => void,
  selectTabKey?: string,
  feesStatus?: string,
  acupointList?: any, //所有穴位数据
  category?:number,//处方类型
): TableColumnType<any>[] => {
  // 根据 id 获取名称
  const getNameById = (id: string): string => {
    // 搜索穴位列表
    for (const firstItem of acupointList?.acupointList || []) {
      for (const secondItem of firstItem?.child || []) {
        for (const thirdItem of secondItem?.child || []) {
          if (thirdItem.id == id) {
            return thirdItem.acuName
          }
        }
      }
    }
    // 搜索身体部位列表
    for (const secondItem of acupointList?.bodyList?.child || []) {
      for (const thirdItem of secondItem?.child || []) {
        if (thirdItem.id == id) {
          return thirdItem.acuName
        }
        for (const fourthItem of thirdItem?.child || []) {
          if (fourthItem.id == id) {
            return fourthItem.acuName
          }
        }
      }
    }
    return id
  }
  return [
    {
      title: "序号",
      dataIndex: "order",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${index + 1}`,
    },
    {
      title: "项目",
      dataIndex: "treatmentServiceName",
      align: "center",
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.treatmentServiceName ? t.treatmentServiceName : "-"
      },
    },
    {
      title: '部位',
      dataIndex: 'treatmentParts',
      align: 'center',
      width: '9rem',
      ellipsis: true,
      render: (_, t) => {
        //中医治疗方需要翻译穴位
        if(category == RecipeCategory.TcmTreat && acupointList!=null){
          const textArr:any = [];
          try {
            const safeArray = JSON.parse(t?.treatmentParts); // 解析字符串
            if(Array.isArray(safeArray)){
              safeArray.map((v) =>{
                textArr.push(getNameById(v))
              })
            }
          } catch (e) {
            console.log("穴位解析异常：",e)
          }
          return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Popover content={textArr.join(',')}>
                <div style={{ width: '80%', textAlign:'left', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  {textArr.join(',')}
                </div>
              </Popover>
            </div>
          )
        }else{
          return t.treatmentParts ? t.treatmentParts : '-'
        }

      },
    },
    {
      title: "用法",
      dataIndex: "normalUsemethod",
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.normalUsemethod ? t.normalUsemethod : "-"
      },
    },
    {
      title: "频次",
      dataIndex: "normalFrequency",
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.normalFrequency ? t.normalFrequency : "-"
      },
    },
    {
      title: "数量",
      dataIndex: "num",
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.num ? t.num + t.doseUnit : "-"
      },
    },
    {
      title: "天数",
      dataIndex: "useDays",
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.useDays ? t.useDays : "-"
      },
    },
    {
      title: "金额",
      dataIndex: "drugAmount",
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.drugAmount >= 0 ? t.drugAmount?.toFixed(2) : "-"
      },
    },
    {
      title: "上次执行人",
      dataIndex: "latelyOperatorName",
      align: "center",
      width: '7rem',
      ellipsis: true,
      render: (_, t) => {
        return t.latelyOperatorName ? t.latelyOperatorName : "-"
      },
    },
    {
      title: "上次执行时间",
      dataIndex: "latelyTime",
      align: "center",
      width: '8rem',
      ellipsis: true,
      render: (_, t) =>
        t.latelyTime ? moment(t.latelyTime).format(DateTimeFormatSimplePrintCharge) : "-",
    },
    {
      title: "执行进度",
      dataIndex: "remainNum",
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return `${(t.totalNumberExecution == -1 ? 0 : t.totalNumberExecution)}/${t.num}` || "-"
      },
    },
    {
      title: "操作",
      align: "center",
      fixed: 'right',
      width: "9rem",
      render: function Element(_, t) {
        return (
          <>
            {
              selectTabKey == '1' || t.totalNumberExecution == t?.num || feesStatus =='5'
                ? ''
                : <Button
                  style={{ marginRight: '6px' }}
                  type='primary'
                  size='small'
                  onClick={() => {
                    onClick('execute', t)
                  }}
                >
                  执行
                </Button>
            }
            <Button
              type='primary'
              ghost
              size='small'
              onClick={() => {
                onClick('record', t)
              }}
            >
              记录
            </Button>
          </>
        )
      },
    },
  ]
}

export const RecordColumns = (
  onClick: (text: string, id: any, coherentVideo?: any) => void,
  startIndex?: number,
  feesStatus?: string,
  acupointList?: any, //所有穴位数据
): TableColumnType<any>[] => {
// 根据 id 获取名称
  const getNameById = (id: string): string => {
    // 搜索穴位列表
    for (const firstItem of acupointList?.acupointList || []) {
      for (const secondItem of firstItem?.child || []) {
        for (const thirdItem of secondItem?.child || []) {
          if (thirdItem.id == id) {
            return thirdItem.acuName
          }
        }
      }
    }
    // 搜索身体部位列表
    for (const secondItem of acupointList?.bodyList?.child || []) {
      for (const thirdItem of secondItem?.child || []) {
        if (thirdItem.id == id) {
          return thirdItem.acuName
        }
        for (const fourthItem of thirdItem?.child || []) {
          if (fourthItem.id == id) {
            return fourthItem.acuName
          }
        }
      }
    }
    return id
  }
  return [
    {
      title: "序号",
      dataIndex: "order",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${index + 1}`,
    },
    {
      title: "执行次数",
      dataIndex: "executeNum",
      align: "center",
      width: '6rem',
      ellipsis: true,
    },
    {
      title: "治疗部位",
      dataIndex: "treatmentParts",
      align: "center",
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        //中医治疗方需要翻译穴位，这里不方便获取处方类型，拿数据结构判断
        const isTcmTreat = t?.treatmentParts?.startsWith('[') && t?.treatmentParts?.endsWith(']');
        if(isTcmTreat){
          const textArr:any = [];
          try {
            const safeArray = JSON.parse(t?.treatmentParts); // 解析字符串
            if(Array.isArray(safeArray)){
              safeArray.map((v) =>{
                textArr.push(getNameById(v))
              })
            }
          } catch (e) {
            console.log("穴位解析异常：",e)
          }
          return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Popover content={textArr.join(',')}>
                <div style={{ width: '80%', textAlign:'left', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  {textArr.join(',')}
                </div>
              </Popover>
            </div>
          )
        }else{
          return t.treatmentParts ? t.treatmentParts : '-'
        }
      }

    },

    {
      title: "开始时间",
      dataIndex: "executeTime",
      align: "center",
      width: '10rem',
      ellipsis: true,
      render: (_, t) =>
        t.executeTime ? moment(t.executeTime).format(DateTimeFormat) : "-",
    },
    {
      title: "结束时间",
      dataIndex: "executeEndTime",
      align: "center",
      width: '10rem',
      ellipsis: true,
      render: (_, t) =>
        t.executeEndTime ? moment(t.executeEndTime).format(DateTimeFormat) : "-",
    },
    {
      title: "执行人",
      dataIndex: "operatorName",
      align: "center",
      width: '9rem',
      ellipsis: true,
    },
    {
      title: "备注",
      dataIndex: "remark",
      width: '8rem',
      ellipsis: true,
      align: "center",
      render: (_, t) => (t.remark ? t.remark : "-"),
    },
    {
      title: "附件",
      dataIndex: "",
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: function element(_, t) {
        return (
          <>
            {t.attachmentFile ? (
              <Button
                type='text'
                style={{ color: "#027aff" }}
                onClick={(e: any) => {
                  onClick("look", t.id, t.attachmentFile)
                }}
              >
                查看
              </Button>
            ) : (
              "-"
            )}
          </>
        )
      },
    },
    {
      title: "操作",
      dataIndex: "",
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: function element(_, t) {
        return (
          <>
            {feesStatus == '5' ? '-' : (
              <Button
                type='link'
                style={{ color: "#027aff" }}
                onClick={(e: any) => {
                  onClick("change", t.id)
                }}
              >
                修改
              </Button>
            )}
          </>
        )
      },
    },
  ]
}

export const ExcuteRecordColumns = (
  onClick: (text: string, val: any, e?: any) => void,
  treatmentPartsList: any,
  edit?: boolean,
  acupointList?:any
): TableColumnType<any>[] => {
  const getNameById = (id: string): string => {
    // 搜索穴位列表
    for (const firstItem of acupointList?.acupointList || []) {
      for (const secondItem of firstItem?.child || []) {
        for (const thirdItem of secondItem?.child || []) {
          if (thirdItem.id == id) {
            return thirdItem.acuName
          }
        }
      }
    }
    // 搜索身体部位列表
    for (const secondItem of acupointList?.bodyList?.child || []) {
      for (const thirdItem of secondItem?.child || []) {
        if (thirdItem.id == id) {
          return thirdItem.acuName
        }
        for (const fourthItem of thirdItem?.child || []) {
          if (fourthItem.id == id) {
            return fourthItem.acuName
          }
        }
      }
    }
    return id
  }
  const { Option } = Select

  const columns: TableColumnType<any>[] = [
    {
      title: "序号",
      dataIndex: "order",
      align: "center",
      width: '3rem',
      render: (_1, _2, index) => `${index + 1}`,
    },
    {
      title: "项目",
      dataIndex: "treatmentServiceName",
      align: "center",
      width: '13rem',
      ellipsis: true,
      render: (_, t) => {
        return t.treatmentServiceName ? t.treatmentServiceName : "-"
      },
    },
    {
      title: '部位',
      dataIndex: 'treatmentParts',
      align: 'center',
      width: '13rem',
      ellipsis: true,
      render: function Element(_, t) {
        //中医治疗方需要翻译穴位，这里不方便获取处方类型，拿数据结构判断
        const isTcmTreat = t?.treatmentParts?.startsWith('[') && t?.treatmentParts?.endsWith(']');
        if(isTcmTreat){
          const textArr:any = [];
          try {
            const safeArray = JSON.parse(t?.treatmentParts); // 解析字符串
            if(Array.isArray(safeArray)){
              safeArray.map((v) =>{
                textArr.push(getNameById(v))
              })
            }
          } catch (e) {
            console.log("穴位解析异常：",e)
          }
          return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Popover content={textArr.join(',')}>
                <div style={{ width: '80%', textAlign:'left', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  {textArr.join(',')}
                </div>
              </Popover>
            </div>
          )
        }else{
          return (
            <div
              style={{
                minHeight: '32px',
              }}
            >
              <Select
                defaultValue={t?.treatmentParts ? (t?.treatmentParts)?.split(',') : []}
                style={{ width: '100%' }}
                placeholder='请选择'
                mode='multiple'
                onChange={(e) => {
                  onClick("changeTreatmentParts", t, e)
                }}
              >
                {TreatmentPartsCategoris?.map((v) => {
                  return (
                    <Option key={v} value={getTreatmentPartsName(v)}>
                      {getTreatmentPartsName(v)}
                    </Option>
                  )
                })}
                {treatmentPartsList?.map((v: any) => {
                  return (
                    <Option key={v.id} value={v.name}>
                      {v.name}
                    </Option>
                  )
                })}
              </Select>
            </div>
          )
        }




      },
    },
    {
      title: "执行进度",
      dataIndex: "totalNumberExecution",
      key: 'totalNumberExecution',
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return `${(t.totalNumberExecution == -1 ? 0 : t.totalNumberExecution)}/${t.num}` || "-"
      },
    },
    {
      title: "本次执行",
      dataIndex: "executeNum",
      align: "center",
      width: '7rem',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{
              width: '120px',
              border: '1px solid #d9d9d9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '2px',
            }}
              className={styles.executeNumMain}
            >
              <Button
                disabled={t.executeNum <= 0}
                style={{
                  border: 'none',
                  borderRight: '1px solid #d9d9d9',
                }}
                icon={<MinusOutlined />}
                onClick={() => {
                  const v = (t.executeNum || 0) - 1
                  onClick("changeExecuteNum", t, v)
                }}
              />
              <InputNumber
                style={{
                  border: 'none',
                  width: '3.5rem',
                  height: '32px',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
                // disabled={t.remainNum == 0}
                value={t.executeNum}
                controls={false}
                onChange={(v: any) => {
                  const reg = new RegExp(/^[0-9]\d*(\.\d)?$/)
                  if (!reg.test(v)) {
                    notification.info({
                      message: '请输入数字，支持小数点后一位',
                    })
                  }
                  onClick("changeExecuteNum", t, v)

                }}
              />
              <Button
                disabled={t.remainNum <= t.executeNum}
                style={{
                  border: 'none',
                  borderLeft: '1px solid #d9d9d9',
                }}
                icon={<PlusOutlined />}
                onClick={() => {
                  const v = (t.executeNum || 0) + 1
                  onClick("changeExecuteNum", t, v)
                }}
              />
            </div>
          </div >
        )
      },
    },
  ]

  return edit ? columns?.filter((item: any) => item?.key != 'totalNumberExecution') : columns
}